module.exports = __webpack_public_path__ + "media/ja_jp_s1_Akira.e968a6da.mp3";